<template>
  <app-chart-wrapper data-grid-area="comments"
                     class="comments">
    <h5>{{$t('message.overview.message.lastComments')}}</h5>

    <ul>
      <li v-for="comment in comments"
          class="comment flex-center"
          :key="comment.id">

        <div>
          <img :src="avatar(comment)"
               class="avatar">
        </div>

        <div class="full-width">
          <div class="flex-space-between">
            <h4 class="client-name">{{comment.name}}</h4>
            {{$date.format(new Date(comment.data))}}
          </div>

          <div class="message">
            {{comment.comment}}
          </div>
        </div>

      </li>
    </ul>

    <div class="overview-comments-footer">
      <router-link :to="{name: 'Comments'}"
                   class="text-primary">
          {{$t('message.overview.message.viewAllComments')}}
      </router-link>
    </div>

  </app-chart-wrapper>
</template>

<script>
    import AppChartWrapper from '@components/chart/ChartWrapper'

    export default {
        components: {
            AppChartWrapper,
        },

        computed: {
            comments() {
                return this.$store.state.statistics && this.$store.state.statistics.overview ?  this.$store.state.statistics.overview.comments : []
            },
        },

        methods: {
          avatar(comment) {
            if(comment.urlAvatar){
              let http = new XMLHttpRequest();

              http.open('HEAD', comment.urlAvatar, false);
              http.send();

              if(http.status === 200) {
                return comment.urlAvatar;
              }
            }

            return '/images/user-avatar-placeholder.png';
          }
        },

        mounted() {
        },

        destroyed() {
            this.$store.commit('COMMENTS_RESET_FILTERS')
        },
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.comments {
  position: relative;
  overflow: hidden;

  .comment {
    padding: 4px;
    margin: 12px 0;
    border-bottom: 1px solid $grey-2;

    .avatar {
      margin-right: 12px;
    }

    .client-name {
      max-width: 240px;
      margin-bottom: 6px;
      font-size: 16px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .message {
      font-size: 14px;

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .overview-comments-footer {
    position: absolute;
    height: 60px;
    background-color: white;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    &:after {
      transform: translateY(-100%);
      content: "";
      position: absolute;
      z-index: 1;
      bottom: -6px;
      left: 0;
      pointer-events: none;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1) 90%
      );
      width: 100%;
      height: 4em;
    }
  }

  @media (max-width: $desktop-md-max) {
    .comment {
      padding: 0;

      .client-name {
        max-width: 180px;
      }
    }
  }
}
</style>
